<template>
  <div
    class="tier-option"
    :class="{ 'tier-option--selected': isSelected }"
    tabindex="0"
    role="option"
    :aria-selected="isSelected"
    @click="handleSelect"
    @keypress.enter="handleSelect"
    @keypress.space.prevent="handleSelect"
  >
    <h1 class="tier-option__heading">{{ content.heading }}</h1>
    <div>
      <div v-dompurify-html="content.description" class="richtext" />
      <PhotochromaticModal
        :isCentered="true"
        v-if="content.hasPhotochromatic"
        :photochromatic="content.photochromatic"/>
    </div>
  </div>
</template>

<script lang="ts">
import PhotochromaticModal from '@/components/molecules/PhotochromaticModal/index.vue'
import { Tier } from '@/model'
import { defineComponent, onMounted, nextTick, ref } from 'vue'

export default defineComponent({
  name: 'TierOption',
  emits: ['select'],
  components: {
    PhotochromaticModal
  },
  props: {
    content: {
      type: Object as () => Tier,
      required: true,
      validator: (value: Tier) => value instanceof Tier
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const handleSelect = () => {
      emit('select', props.content)
    }

    onMounted(() => {
      nextTick(() => {
      const selectedCard: HTMLElement|null = document.querySelector('.selection-card--is-selected')
      const selectedTierOption: HTMLElement|null = document.querySelector('.tier-option--selected')
      const moreInfoModal: HTMLElement|null = document.querySelector('.more-info')
      selectedCard?.focus()
        setTimeout(() => {
          if(!moreInfoModal){
            selectedTierOption?.focus()
          }
        }, 0)
      })
    })
    return {
      handleSelect
    }
  }
})
</script>

<style scoped>
.tier-option {
  transition: background-color 250ms ease-out;
  @apply cursor-pointer border-gray-base border-2 rounded bg-gray-base flex text-left p-4;

  &:focus {
    @apply outline-none;
  }
  body:not(.using-mouse) &:focus {
    @apply border-black-darkest;
  }
  &:hover,
  &--selected {
    @apply bg-primary-light border-primary-light;
  }

  &__heading {
    min-width: 80px;
    @apply mr-4 font-bold;
  }
}

@screen md {
  .tier-option {
    min-height: 336px;
    flex-grow: 0;
    flex-shrink: 0;
    width: 235px;
    @apply block text-center px-6 pt-12 pb-8;

    &__heading {
      @apply mr-0 mb-8 text-xl;
    }
  }
}
</style>
